import { render, staticRenderFns } from "./CardCommunityNotification.vue?vue&type=template&id=d0a525d2"
import script from "./CardCommunityNotification.vue?vue&type=script&lang=js"
export * from "./CardCommunityNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports